import * as React from 'react';
import { DropdownMenu, SortOrder } from 'ui';
import * as navigate from 'app/area/shared/navigation';
import { SortOptions } from 'ui/sort-order/types';
import { MdArrowDropDown } from 'react-icons/md';
import { SharedState } from 'app/types-shared';
import { FavouriteContextMenu } from './favourite-context-menu';

import styles from './display-options.scss';
import { FavouriteReportDownload } from 'app/area/favourite/types';

export interface DisplayOptionsLinkProps {
  value: number;
  isActive: boolean;
  description: string;
}

class DisplayOptionsLink extends React.Component<DisplayOptionsLinkProps, {}> {

  private onClick = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    navigate.toSearch({ report: this.props.value.toString(10) });
  };

  public render() {
    return (<button type="button" onClick={this.onClick} className={`dropdown-item ${this.props.isActive && 'active'}`}>
      {this.props.description}
    </button>
    );
  }
}

export interface DisplayOptionsProps {
  sortOptions?: SortOptions;
  reportCategory?: any;
  report: number;
  favouriteId: number;
  translation: any;
  sharedState: SharedState;
  loadSortOptions: () => void;
  updateSortOptions: (options: SortOptions) => void;
  fetchingSortOptions: boolean;
  createReport: () => void;
  showUpdate: boolean;
  updateReport: () => void;
  displayExportToZip: () => void;
  downloadReport: (data: FavouriteReportDownload) => void;
  getMulitpleSuppliersUrl: () => void;
  urlMultipleSuppliers: string;
}

export const DisplayOptions = (props: DisplayOptionsProps) => {

  const { report, reportCategory } = props;

  const selectedOption = reportCategory.find(r => r.value === report);
  const toggle = <div>
    <span>{selectedOption && selectedOption.description}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  const onDone = (options: SortOptions) => {
    props.updateSortOptions(options);
  };

  return <div className={styles.main}>
    <div className={styles.sortOrder}>
      <SortOrder
        componentId={'1'}
        translation={props.translation}
        options={props.sortOptions}
        loadOptions={props.loadSortOptions}
        onDone={onDone}
        fetching={props.fetchingSortOptions} />
    </div>
    <div className={styles.viewAs}>
      <span className={styles.outerLabel}>{props.translation.view_as}</span>
      <DropdownMenu dropdownNode={toggle} closeAfterClick>
        {props.reportCategory.map(c => (
          <DisplayOptionsLink
            key={c.value}
            value={c.value}
            isActive={c.value === report}
            description={c.description} />
        ))}
      </DropdownMenu>
    </div>
    <FavouriteContextMenu
      {...props} 
    />
  </div>;
};
